import utils from '@src/common/utils'
import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '设备名称',
        prop: 'fireassetName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        align: 'center'
      },
      {
        label: '设备类型',
        prop: 'fireassetType',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU077', value) : '';
        }
      },
      {
        label: '所在区域',
        prop: 'areaName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      }, 
      {
        label: '设备状态',
        prop: 'assetState',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return '正常'
          } else if (Number(value) === 2) {
            return '故障'
          } 
          return '';
        }
      }, 
      {
        label: '巡检时间',
        prop: 'patrolTime',
        type: 'datetime',
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '巡检状态',
        prop: 'taskStatus',
        type: 'select',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        // formslot: true,
        span: 12,
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '待巡检'
          } else if (Number(value) === 2) {
            return '已完成'
          } 
          return '';
        },
        dicData: [
          {
            label: '待巡检',
            value: 1
          },
          {
            label: '已完成',
            value: 2
          }
        ],
        align: 'center',
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return '待巡检'
          } else if (Number(value) === 2) {
            return '已完成'
          } 
          return '';
        }
      },
      {
        label: '描述',
        prop: 'assetDesc',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center'
      }
    ]
  }
}
export default tableOption